<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
      .default-modal-body.register-body
        .mb-2
        .register-row
          .register-group
            .register-key.mb-3
              span.key-name ログインする施設を選択してください

            .facility-select.w-100
              b-dropdown.w-100(
                variant="outline-secondary"
                menu-class="w-100 scrollable-menu"
                toggle-class="d-flex justify-content-between align-items-center custom-select-toggle"
              )
                template(#button-content)
                  span.facility-name.text-left.flex-grow-1.ml-2 {{ selectedFacilityLabel || "施設を選択してください" }}
                b-dropdown-form
                  b-input-group.search-filter-input-group(size="md" @click.stop)
                    b-input-group-prepend
                      b-input-group-text.search-filter-icon
                        .search-icon
                    b-form-input.search-filter-input(
                      v-model="searchWord"
                      type="search"
                      placeholder="検索施設名を入力してください"
                    )
                b-dropdown-divider
                b-dropdown-item(
                  v-for="option in _filteredFacilityOptions"
                  :key="option.value"
                  @click="selectFacility(option.value)"
                ) {{ option.label }}

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(@click="ok" :class="{ 'disable': !facilityId }" :disabled="!facilityId") {{ okButtonLabel }}
        b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";

/**
 * ### 施設選択モーダル
 */
@Component({
  components: {
    FormInputSelect
  }
})
export default class FacilitySelectModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "OK" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  @Prop({ default: () => "pc" })
  type!: string;

  @Prop()
  facilityId!: number;

  @Prop({ default: () => [] })
  facilityOptions!: Array<{ value: number | string; label: string }>;

  /** 事業所名を絞り込む検索ワード */
  searchWord: string = "";

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _facilityId(): number {
    return this.facilityId;
  }

  set _facilityId(newValue: number) {
    this.$emit("update:facilityId", newValue);
    return;
  }

  get selectedFacilityLabel(): string {
    const found = this.facilityOptions.find((opt) => opt.value === this.facilityId);
    return found ? found.label : "";
  }

  get _filteredFacilityOptions() {
    const word = this.searchWord.toLowerCase();
    return this.facilityOptions.filter((option) => option.label.toLowerCase().includes(word));
  }

  public selectFacility(value: number): void {
    this._facilityId = value;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>

<style lang="scss">
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";
.facility-select {
  .scrollable-menu {
    max-height: 250px;
    overflow-y: auto;
  }

  .facility-name {
    font-size: 16px;
  }

  .search-filter-input-group {
    .search-filter-icon {
      background-color: #fff !important;
      .search-icon {
        @include svg-icon("../../assets/search.svg", $font-base-color, 20px, 20px);
      }
    }
    .search-filter-input {
      border-left: 0;
    }
  }

  .custom-select-toggle {
    background-color: $bg-default !important;
    border: 1px solid $form-border-color !important;
    color: $font-base-color !important;
    height: 42px;
    padding: 6px 12px;
    box-shadow: none !important;

    &:hover,
    &:focus,
    &:active,
    &.show > .btn-secondary.dropdown-toggle {
      background-color: $bg-default !important;
      border-color: $form-border-color !important;
      color: $font-base-color !important;
    }

    &:focus,
    &.focus {
      outline: none;
      box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color !important;
      border: 1px solid $form-border-select-color !important;
    }

    &::after {
      margin-left: 10px;
    }
  }
}
</style>
